/** iOS-style switch that swaps the right-column card between the
 *  per-country rollup (default, OFF) and the 4-KPI predictions panel
 *  (ON). Earlier version was a segmented control rendered inline in
 *  each card's header — but because ByCountryCard's header also
 *  carries a metric-labels string + pencil button and the prediction
 *  card does not, the segmented control ended up at different
 *  horizontal positions in the two modes. Click the toggle, and the
 *  very element you just clicked would jump.
 *
 *  This component is still parked in the header, but its geometry
 *  is fixed (label + 46×26 track) and in both card variants it's
 *  the very first thing on the trailing edge of the header — the
 *  "Columns" label / pencil button drift leftward in country mode
 *  around it instead of shoving it sideways. Net effect: clicking
 *  the toggle in one mode lands you on the same toggle in the other
 *  mode at the same screen position. */
export function ByCountryModeToggle({
  value,
  onChange,
}: {
  value: "country" | "prediction";
  onChange: (m: "country" | "prediction") => void;
}) {
  const on = value === "prediction";
  return (
    <label
      className={`ios-toggle${on ? " on" : ""}`}
      title="Toggle D30 predictions view"
    >
      <span className="ios-toggle-label">Predictions</span>
      <input
        type="checkbox"
        checked={on}
        onChange={(e) => onChange(e.target.checked ? "prediction" : "country")}
        aria-label="Show D30 predictions instead of country rollup"
      />
      <span className="ios-toggle-track" />
    </label>
  );
}
